/* eslint-disable no-underscore-dangle */
/* global theme */

/**
 *
 * @param {object} item product object
 * @returns {number} return inventory quantity
 */
globalThis.setItemInventory = (item) => {
  const currentCartVariantID = item.id;
  const currentCartVariantData = item?.product?.variants?.filter(
    (variant) => variant.id === currentCartVariantID
  )[0];
  if (currentCartVariantData) {
    const inventoryQuantity =
      currentCartVariantData?.inventory_quantity >
      +theme.settings.productMaxQuantity
        ? theme.settings.productMaxQuantity
        : currentCartVariantData.inventory_quantity;
    return inventoryQuantity;
  }
  return null;
};

/**
 * Method to remove products from cart based on their index
 * @param {number} line_item_index index of product in the cart
 */
globalThis.removeLineFromCart = (line_item_index) => {
  if (!line_item_index) return;
  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: line_item_index,
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });
};

/**
 *
 * @param {object} eventDetail event detail object
 */
function updateQuantityToMaxQtySettings(eventDetail) {
  const itemInCart = eventDetail.cart
    .getItems()
    .filter((item) => item.variant_id === eventDetail.item.variant_id)[0];
  if (+eventDetail.item.quantity > +theme.settings.productMaxQuantity) {
    globalThis.RebuyCart.setItemQuantity(
      itemInCart,
      theme.settings.productMaxQuantity,
      () => {
        if (!globalThis.SmartCart.visible) globalThis.SmartCart.show();
      }
    );
  }
}

/**
 * Add to cart function
 *
 * @param {object} items object with products
 * @param {HTMLElement} loader html element
 */
function addProductsToCart(items, loader) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(items),
  })
    .then((response) => response.json())
    .then(() => {
      const targetNode = document.querySelector('.rebuy-cart__flyout-items');
      const config = { childList: true };
      const reRenderCartItemsObserver = new MutationObserver(
        (mutationsList, observer) => {
          mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              if (loader.classList.contains('active'))
                loader.classList.remove('active');
              observer.disconnect();
            }
          });
        }
      );
      reRenderCartItemsObserver.observe(targetNode, config);
    })
    .catch((error) => console.error(error));
}

/**
 *
 * @param {object} update object with data to update quantity - remove from cart
 * @param {Array} add array with data to add to cart - removed product add without discount
 * @param {HTMLElement} loader loader element
 */
function replaceDiscountedBoundleItems(update, add, loader) {
  fetch(`/cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ updates: update }),
  })
    .then((response) => {
      return response.json();
    })
    .then(() => {
      addProductsToCart(add, loader);
    })
    .catch((err) => console.error(err));
}

/**
 *
 * @param {number} originBundleID id bundle widget
 */
function updateSmartCartItems(originBundleID) {
  const loader = document.querySelector('.rebuy-cart__flyout-loader');

  const update = {};
  const add = {
    items: [],
  };
  globalThis.RebuyCart.fetchShopifyCart((cart) => {
    const itemsFromOneBundle = cart.items.filter(
      (item) =>
        item.properties._origin_bundle_product_id === originBundleID &&
        item.discounts.length > 0
    );
    if (itemsFromOneBundle.length > 0) {
      itemsFromOneBundle.forEach((product) => {
        update[product.variant_id] = 0;
        add.items.push({
          id: product.variant_id,
          quantity: 1,
        });
      });
    }
    if (Object.keys(update).length > 0 && add.items.length > 0) {
      loader.classList.add('active');
      replaceDiscountedBoundleItems(update, add, loader);
    }
  });
}

/**
 * The smartCartOpen method is a method for show smart cart.
 *
 * @name smartCartOpen
 * @kind function
 */
function smartCartOpen() {
  window.Rebuy.SmartCart.show();
}

/**
 * The setItemCount method is a method for set cart item count
 * to cart icon elements.
 *
 * @name setItemCount
 * @kind function
 * @param {object} element The cart icon elemelt
 */
function setItemCount(element) {
  const itemCount = window.Rebuy?.Cart?.cart?.item_count;
  const cartIcon = element;
  cartIcon.dataset.cartCount = itemCount > 0 ? itemCount : '';
}

/**
 * The getShemaData method is a method for get data
 * of section schema.
 *
 * @name getShemaData
 * @kind function
 * @param {string} shemaDataId The id of schema data.
 * @returns {any} The generated response return schema data or false.
 */
function getShemaData(shemaDataId) {
  const sectionData = document.getElementById(shemaDataId);
  if (!sectionData || !sectionData.innerHTML.length) return false;

  try {
    return JSON.parse(sectionData.innerHTML);
  } catch (error) {
    return false;
  }
}

/**
 * The getShemaDataItem method is a method for get data item
 * of section schema.
 *
 * @name getShemaDataItem
 * @kind function
 * @param {string} item The name of schema data item.
 * @param {string} shemaDataId The id of schema data.
 * @returns {string} The generated response return data item of schema.
 * If not exist in the data you get an empty string.
 */
window.getShemaDataItem = (item, shemaDataId = 'SmartCartJson') => {
  const data = getShemaData(shemaDataId);
  const parents = item.split('.');
  if (parents.length > 0)
    return parents.reduce((p, c) => (p[c] === undefined ? '' : p[c]), data);
  if (data[item] === undefined) return '';
  return data[item];
};

/**
 * The removeDiscount method is a method for remove
 * discount from cart and checkout.
 *
 * @name removeDiscount
 * @kind function
 */
window.removeDiscount = () => {
  localStorage.removeItem('discount_code');
  window.Rebuy.SmartCart.removeDiscount();
  window.Rebuy.SmartCart.discount.inputValue = '';
};

/**
 * The getProductsRulesData method is a method for get data for ProductsRules.
 * @name getProductsRulesData
 * @kind function
 * @returns {object} The list of paramentrs for ProductsRules.
 */
function getProductsRulesData() {
  const subString = 'SmartCartProductsRulesJson_';
  const productsRulesJsons = document.querySelectorAll(`[id^="${subString}"]`);
  return [...productsRulesJsons].reduce((previousValue, currentValue) => {
    if (!currentValue || !currentValue.innerHTML.length) return previousValue;

    const data = JSON.parse(currentValue.innerHTML);
    if (!data) return previousValue;
    return { ...previousValue, [currentValue.id.replace(subString, '')]: data };
  }, {});
}

/**
 * The setProductsRules method is a method for set products rules.
 * Adding rules for products from the list that will be automatically
 * removed from the cart when the total price in the cart does not meet
 * the conditions.
 * @name freeShippingMinimum
 * @kind function
 */
function setProductsRules() {
  if (!window.Rebuy.Cart) return;
  const data = getProductsRulesData();
  const { subtotal, items, removeItem } = window.Rebuy.Cart;

  window.Rebuy.SmartCart.settings.productsRules = [];
  Object.entries(data).forEach(([blockId, value]) => {
    const {
      cart_total_price: cartTotalPrice,
      product_list: productList,
      removed_product_message: message,
      color_scheme: color,
      hide_quantity: quantity,
      removed_product_message_speed: speed,
    } = value;
    window.Rebuy.SmartCart.settings.productsRules = [
      ...window.Rebuy.SmartCart.settings.productsRules,
      ...productList.map(({ handle }) => ({ handle, quantity: quantity === true || undefined })),
    ];
    if (subtotal() >= cartTotalPrice) return;
    const productToDestroy = items().filter((item) => productList
      .find(({ handle }) => handle === item.handle));
    if (!productToDestroy.length) return;

    productToDestroy.forEach((product, productIndex) => {
      const itemClass = `${blockId}_${productIndex}`;
      window.Rebuy.SmartCart.settings.productsToDestroy = window
        .Rebuy.SmartCart.settings.productsToDestroy || [];
      window.Rebuy.SmartCart.settings.productsToDestroy.push({
        product, message, color, class: itemClass,
      });
      setTimeout(() => [...document.getElementsByClassName(itemClass)].forEach((i) => i.classList.add('remove')), speed);
      setTimeout(() => {
        window.Rebuy.SmartCart.settings.productsToDestroy = window.Rebuy.SmartCart.settings
          .productsToDestroy.filter(({ product: { handle } }) => handle !== product.handle);
        removeItem(product);
      }, !speed ? 0 : speed);
    });
  });
}

/**
 * The isItemToDestroy method is a method for checking if
 * this item must to destroy.
 * @name isItemToDestroy
 * @kind function
 * @param {object} item The cart item.
 * @returns {object | undefined} The generated parameters.
 */
window.isItemToDestroy = (item) => (
  window.Rebuy.SmartCart.settings.productsToDestroy || [])
  .find((i) => i.product === item);

/**
 * The smartCartRun method is a method for open smart cart when
 * rebuy.smartcart.ready listener loaded up, set trigger open
 * on cart icon elements, and set cart item count.
 *
 * @name smartCartRun
 * @kind function
 * @param {boolean} open The param in boolean type
 * to open smart cart after smart cart ready.
 */
function smartCartRun(open) {
  document.addEventListener('rebuy:smartcart.ready', () => {
    if (open === true) smartCartOpen();
    const dataCartIcon = '[data-cart-icon]';
    document.querySelectorAll(dataCartIcon).forEach((i) => {
      document.addEventListener('rebuy:cart.ready', () => setItemCount(i));
      i.addEventListener('click', smartCartOpen);
    });
    setProductsRules();
    document.addEventListener('rebuy:cart.change', () => {
      setProductsRules();
      document.querySelectorAll(dataCartIcon).forEach((i) => setItemCount(i));
    });
    document.addEventListener('rebuy:cart.add', (event) => {
      updateQuantityToMaxQtySettings(event?.detail);
    });
    document.addEventListener('rebuy:smartcart.show', () =>
      document.querySelector('body').classList.add('rebuy-smart-cart-opened')
    );
    document.addEventListener('rebuy:smartcart.hide', () =>
      document.querySelector('body').classList.remove('rebuy-smart-cart-opened')
    );
    document.addEventListener('rebuy:cart.ready', () => {
      globalThis.RebuyCart = window.Rebuy.Cart;
      document.addEventListener('rebuy:smartcart.product-removed', (event) => {
        const removedProduct = event.detail.product;
        if (
          removedProduct.properties._attribution ===
          'Rebuy Dynamic Product Bundle'
        ) {
          const bundleOriginProductID =
            removedProduct?.properties?._origin_bundle_product_id;
          if (bundleOriginProductID)
            updateSmartCartItems(bundleOriginProductID);
        }
      });
    });
    document.addEventListener('rebuy:smartcart.line-item-removed', (event) => {
      if (event.detail.smartcart.itemCount() === 1) window.removeDiscount();
    });
  });
}

smartCartRun();
